import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import { Router } from '@angular/router';
import {StorageService} from "./internals/storage.service";
import { SecureStorageService } from './internals/secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GroovePlanApiService {
  entityUrl = '';
  constructor(public _httpClient: HttpClient,
              public storageService: StorageService,
              public secureStorage: SecureStorageService,
              public router: Router) {

  }

  async getAuthHeaders(): Promise<HttpHeaders> {
    let headers = new HttpHeaders();

    const authToken = await this.secureStorage.get<string>('authToken');

    if (!authToken) {
      this.router.navigate(['login']);
      return headers;
    }

    headers = headers.set(
      'Authorization',
      `Bearer ${authToken}`
    );

    // Timezone du client
    const timeZone = Intl.DateTimeFormat()
      .resolvedOptions()
      .timeZone;

    headers = headers.set(
      'client-timezone',
      timeZone
    );

    return headers;
  }

  async getRefreshHeaders(): Promise<HttpHeaders> {
    let headers = new HttpHeaders();
    const authToken = await this.secureStorage.get('refreshToken');
    if(!authToken) {
      this.router.navigate(['login']);
    }
    headers = headers.append('Authorization', 'Bearer '+authToken);
    // Récupération de la timezone courante du navigateur
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    headers = headers.append('client-timezone', timeZone);
    return headers;
  }

  async count(filterTab: any) {
    const headers = await this.getAuthHeaders();
    const filterString = this.formatFilterUrl(filterTab);
    return this.get(this.entityUrl + '/count' + filterString, headers);
  }

  async findBy(filterTab: any) {
    const headers = await this.getAuthHeaders();
    const filterString = this.formatFilterUrl(filterTab);
    return this.get(this.entityUrl + filterString, headers);
  }

  async getOneById(id: string|number) {
    let headers = await this.getAuthHeaders();
    return this.get(this.entityUrl+'/'+id, headers);
  }

  async getAll() {
    let headers = await this.getAuthHeaders()
    return this.get(this.entityUrl, headers);
  }

  async create(body: any) {
    let headers = await this.getAuthHeaders()
    return this.post(this.entityUrl, body, headers)
  }

  async createMultiple(body: any) {
    let headers = await this.getAuthHeaders()
    return this.post(this.entityUrl+'/multiple', body, headers)
  }

  async deleteMultiple(idGroupe: any, ids: any) {
    const idsStr = ids.join('-');
    let headers = await this.getAuthHeaders()
    return this.delete(this.entityUrl+'/multiple/'+idGroupe, idsStr, headers)
  }

  async deleteById(id: any) {
    let headers = await this.getAuthHeaders()
    return this.delete(this.entityUrl, id, headers)
  }

  async updateById(id: any, body: any) {
    let headers = await this.getAuthHeaders()
    return this.patch(this.entityUrl, id, body, headers)
  }

  get(url: string, headers: HttpHeaders|null = null) {
    if(!headers) {
      headers = new HttpHeaders();
    }
    return this._httpClient.get(environment.apiUrl+'/'+url, {headers: headers});
  }

  delete(url: string, id:any, headers: HttpHeaders|null = null) {
    if(!headers) {
      headers = new HttpHeaders();
    }
    return this._httpClient.delete(environment.apiUrl+'/'+url+(id ? '/'+id : ''), {headers: headers});
  }

  post(url: string, body: any, headers: HttpHeaders|null = null) {
    if(!headers) {
      headers = new HttpHeaders();
    }
    return this._httpClient.post(environment.apiUrl+'/'+url, body, {headers: headers});
  }

  // Ne pas fixer de Content-Type : le navigateur doit gerer lui-meme la boundary multipart
  postFormData(url: string, formData: FormData, headers: HttpHeaders|null = null) {
    if(!headers) {
      headers = new HttpHeaders();
    }
    return this._httpClient.post(environment.apiUrl+'/'+url, formData, {headers: headers});
  }

  private patch(url: string, id:any, body: any, headers: HttpHeaders|null = null) {
    if(!headers) {
      headers = new HttpHeaders();
    }
    return this._httpClient.patch(environment.apiUrl+'/'+url+'/'+id, body, {headers: headers});
  }

  private formatFilterUrl(filterTab: any) {
    let filterString = '?';
    for (let i in filterTab) {
      if(filterTab[i] === true) {
        filterTab[i] = '1';
      } else if(filterTab[i] === false) {
        filterTab[i] = '0';
      }
      filterString += i + '=' + filterTab[i] + '&';
    }
    filterString = filterString.slice(0, -1);
    return filterString;
  }
}
